'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreeSample = exports.DATA_VARIANT_ID = exports.CLASS_DISABLED = exports.VARIANT_ID = exports.PRODUCT_JSON_SELECTOR = exports.FREE_SAMPLE_ADD_BTN = exports.FREE_SAMPLE_CAROUSEL = exports.FREE_SAMPLE_BUTTON = exports.CONTAINER_SELECTOR = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _ShopifySection2 = require('./../../sections/ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Products Carousel
 *
 *  Version:
 *    1.0.0 - 2020/11/20
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-free-sample]';
var FREE_SAMPLE_BUTTON = exports.FREE_SAMPLE_BUTTON = '[data-free-sample-button]';
var FREE_SAMPLE_CAROUSEL = exports.FREE_SAMPLE_CAROUSEL = '[data-free-sample-carousel]';
var FREE_SAMPLE_ADD_BTN = exports.FREE_SAMPLE_ADD_BTN = '[data-free-sample-add-btn]';
var PRODUCT_JSON_SELECTOR = exports.PRODUCT_JSON_SELECTOR = '[data-product-json]';
var VARIANT_ID = exports.VARIANT_ID = '[data-variant-id]';

//Classes
var CLASS_DISABLED = exports.CLASS_DISABLED = 'is-disabled';

// Data attributes
var DATA_VARIANT_ID = exports.DATA_VARIANT_ID = 'data-variant-id';

var IS_HIDDEN = 'is-hidden';
var IS_COMPLETE = 'is-complete';

var FreeSample = exports.FreeSample = function (_ShopifySection) {
  (0, _inherits3.default)(FreeSample, _ShopifySection);

  function FreeSample(container) {
    (0, _classCallCheck3.default)(this, FreeSample);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FreeSample.__proto__ || Object.getPrototypeOf(FreeSample)).call(this, container));

    _this.container = container;

    $(document).on('click', FREE_SAMPLE_BUTTON, function () {
      return _this.showFreeSamples();
    });
    $(document).on('click touch', FREE_SAMPLE_ADD_BTN, function (e) {
      return _this.addProduct(e);
    });
    return _this;
  }

  (0, _createClass3.default)(FreeSample, [{
    key: 'showFreeSamples',
    value: function showFreeSamples() {
      $(FREE_SAMPLE_CAROUSEL).removeClass(IS_HIDDEN);
      $(FREE_SAMPLE_BUTTON).addClass(IS_HIDDEN);
    }
  }, {
    key: 'addProduct',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var self, freeSampleThumbnail, props, id, sampleCarousel;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                self = $(e.currentTarget);
                freeSampleThumbnail = self.closest(VARIANT_ID);

                // Build free sample props

                props = {};

                props._free_sample = true;

                id = $(freeSampleThumbnail).attr(DATA_VARIANT_ID);

                // Hide add button

                sampleCarousel = this.container.find(FREE_SAMPLE_CAROUSEL);

                sampleCarousel.addClass(IS_HIDDEN);
                sampleCarousel.addClass(IS_COMPLETE);

                _context.prev = 10;
                _context.next = 13;
                return (0, _pcSlateTools.addToCart)(id, 1, props);

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](10);

                //Error, show error, enable buttons hide loader
                console.error('Failed to add to cart.');
                return _context.abrupt('return');

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 15]]);
      }));

      function addProduct(_x) {
        return _ref.apply(this, arguments);
      }

      return addProduct;
    }()
  }]);
  return FreeSample;
}(_ShopifySection2.ShopifySection);